export default __webpack_public_path__ + "static/media/ic-sm-cultivation-1.494ef907.svg";